import { CHART_TEXT } from '../constants';

import { formatDateForTable } from './dateFormatHelpers';

const formatTableDate = formatDateForTable;

/**
 * Formats score values for table display
 */
const formatTableScore = (value: number): string => value.toString();

/**
 * Creates table configuration for accessibility trends chart
 */
export const createTableProps = (): {
	dataType: 'Date';
	columnsPattern: Array<{
		name: string;
		field: string;
		formatter: (value: string | number) => string;
	}>;
} => ({
	dataType: 'Date' as const,
	columnsPattern: [
		{
			name: CHART_TEXT.TABLE_COLUMNS.DATE,
			field: 'date',
			formatter: formatTableDate
		},
		{
			name: CHART_TEXT.TABLE_COLUMNS.SCORE,
			field: 'score',
			formatter: formatTableScore
		}
	]
});
